import React from 'react';
import { Link } from 'react-router-dom';
const Nav = () => {
	return (
		<React.Fragment>
			<nav>
				<div className="container">
					<span className="logo">
						<strong>
							{' '}
							<Link to="/">EVENT MANAGER</Link>
						</strong>
					</span>
					<ul>
						<li className="nav">
							<a href="http://mydy.dypatil.edu/">Contact us</a>
						</li>
						<li className="nav">
							<a href="https://github.com/HekarKET/EVM">Source code</a>
						</li>
						<li className="nav">
							<a href="https://stream-ema.herokuapp.com/" target="_blank">
								Stream
							</a>
						</li>
					</ul>
					<i className="fa fa-bars" aria-hidden="true" id="nav-bars"></i>
				</div>
			</nav>
		</React.Fragment>
	);
};

export default Nav;
